import React, { useEffect } from "react";
import { useState } from "react";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate ,useParams} from "react-router-dom";
import {  getAnalyticalData } from "../../services/Store/Actions/fleetActions";

import { ToastContainer } from "react-toastify";
import { PieChart } from '@mui/x-charts/PieChart';
import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from '@mui/x-charts';
import { Paper } from "@mui/material";
import { makeStyles } from '@mui/styles';
import { LineChart } from '@mui/x-charts/LineChart';

function VehicleAnalytics(props) {
  const { sideBar } = props;
  let { id } = useParams();
  console.log("VehicleProfile",id);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const dispatch = useDispatch();
  const analyticalData = useSelector((state) => state?.fleet?.analyticalData);
  

  useEffect(() => {
    console.log("VehicleProfile111",id);

    dispatch(getAnalyticalData({fleetId: id}, (res)=> {
        console.log("getAnalyticalData", res);
    }));
  }, []);

  const chartSetting = {
    yAxis: [
      {
        label: '',
      },
    ],
    width: 500,
    height: 300,
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: 'translate(-10px, 0)',
      },
    },
  };

const dataset = [
  {
    earning: 0,
    expanse: 0,
    tripNo: 'TR - 1',
  },
  {
    earning: 0,
    expanse: 0,
    tripNo: 'TR - 2',
  },
  {
    earning: 0,
    expanse: 0,
    tripNo: 'TR - 3',
  }
];
const valueFormatter = (value) => `Rs. ${value}`;
const useStyles = makeStyles({
  root: {  
      padding: 8,
      backgroundColor: '#FBECE4',
      }
  
});
const CustomItemTooltipContent = (props) => {
  const { itemData, series } = props;
  console.log('CustomItemTooltipContentCustomItemTooltipContent',itemData,series);
  const classes = useStyles();
  return (
    <Paper outlined className={classes.root} >
      {/* <p>{series.label}</p> */}
      <p>{series.data[itemData.dataIndex].label}: {series.data[itemData.dataIndex].value}</p>
    </Paper>
  );
};

const CustomItemTooltipContentTrip = (props) => {
  const { itemData, series } = props;
  console.log('CustomItemTooltipContentTrip',itemData,series);
  const classes = useStyles();
  return (
    <Paper outlined className={classes.root} >
      {/* <p>{series.label}</p> */}
      <p>{series?.label?series?.label+" : ":''}  {series.data[itemData.dataIndex]}</p>
    </Paper>
  );
};
  return (
    <div
      className="container topMargin sideBarMargin"
      style={{
        // paddingTop:"5.5rem",
        marginLeft: sideBar ? "220px" : "100px",
        maxWidth: sideBar ? windowWidth - 240 : windowWidth - 130,
      }}
    >
      <div
        className="main1"
        style={{ height: "1200px", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", flexDirection:"row", justifyContent:"space-between" ,justifyContent:'center'}}>
          <div>
            <h1 className="headingLow semiBold" style={{ marginBottom: "25px" ,}}>
              Vehicle Analytics
            </h1>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection:"row", justifyContent:"space-between" ,marginTop:'120px'}}>
          
          <div >
            <h5 style={{textAlign:'center'}}>Last 3 Trips Net Earnings Per kilometer</h5>
            
                <LineChart
                  xAxis={[{ scaleType: 'band', data: analyticalData?.finalTripData.map(e=>e.tripNo)||[1,2,3] }]}
                  tooltip={{trigger: 'item',itemContent: CustomItemTooltipContentTrip}}
                  series={[
                    {
                      data: analyticalData?.finalTripData.map(e=>e.nepk)||[0,0,0],
                    },
                  ]}
                  width={500}
                  height={300}
                />
          </div>
          <div>
            <h5 style={{textAlign:'center'}}>Last 3 Trips Earnigs/Expense</h5>
            {/* <BarChart
                xAxis={[{ scaleType: 'band', data: ['Trip A', 'Trip B', 'Trip C'] }]}
                series={[{ data: [4, 3, 5] }, { data: [1, 6, 3] }]}
                width={500}
                height={300}
              /> */}
              <BarChart
                  dataset={analyticalData?.finalTripData||dataset}
                  xAxis={[{ scaleType: 'band', dataKey: 'tripNo' }]}
                  tooltip={{trigger: 'item',itemContent: CustomItemTooltipContentTrip}}
                  series={[
                    { dataKey: 'earning', label: 'Earning', valueFormatter },
                    { dataKey: 'expanse', label: 'Expense', valueFormatter },
                  ]}
                  {...chartSetting}
                />
          </div>
          
          
        </div>
        <div style={{textAlign:'-webkit-center'}} >
          <h5 style={{textAlign:'center'}}>Vehicles Expenses</h5>
          <PieChart
            margin={{top: 50, right: 200}}
            tooltip={{trigger: 'item',itemContent: CustomItemTooltipContent}}
            series={[
              {
                data:analyticalData?.finalData ? analyticalData?.finalData :[{ id: 0, value: 100, label: 'No Data' }],
                
                innerRadius: 50,
                // outerRadius: 100,
                paddingAngle: 5,
                cornerRadius: 5,
                // color: ""
                // startAngle: -90,
                // endAngle: 180,
              }
            ]}
            width={500}
            height={250}
            
          />
          </div>
    </div>
    <ToastContainer
          theme="light"
          position="top-right"
          closeOnClick
          pauseOnHover
          autoClose={3000}
        />
    </div>
  );
}

export default VehicleAnalytics;
